import axios from 'axios';

export const setAxiosDefaults = (token?: string) => {
    (axios.defaults.headers as any)['X-PublicToken'] = token;
};
